<template>
    <b-modal id="editModal" ref="modal" title="Edit district" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>District Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!district.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="district.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteDistrictMutation from '@views/Districts/EditModal/mutationDeleteDistrict.graphql';
import restoreDistrictMutation from '@views/Districts/EditModal/mutationRestoreDistrict.graphql';
import updateDistrictMutation from '@views/Districts/EditModal/mutationUpdateDistrict.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    district: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.district.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateDistrictMutation,
            variables: {
              input: {
                id: this.district.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateDistrict: {
                ...this.district,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('District updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteDistrictMutation,
          variables: {
            input: {
              id: this.district.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('District disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreDistrictMutation,
          variables: {
            input: {
              id: this.district.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreDistrict: {
              ...this.district,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('District restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
